module.exports = "<abbr title=\"Add image\"><mat-icon>panorama</mat-icon></abbr>"